export enum ValidationState{
    Error,
    Warning,
    Success,
    None
    }